export function canonicalPath(pathname: string): string {
  if (!pathname) {
    return '/';
  }
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed === '' ? '/' : `${trimmed}/`;
}
